/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const programName = queryKey[2];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_conversion_factor?loyalty_program=${programName}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchConversionFactor = (programName: string) => {
  const { url } = useSelector(selectAuth);
  return useQuery(['conversion', url, programName], fetcher, {
    enabled: !!programName,
  });
};
